import { Dropdown, TextField } from '@cambridgeassessment/cambridge-ui';
import { Consortium, CentreBase } from '@cambridgeassessment/lib-ee-commons';
import React from 'react';
import { StyledInputContainer } from '../Content.styles';
import { ModalSubtitleStyled, ModalTitleStyled } from './ManageSampleChanges.styles';

interface Props {
  headerStr: string;
  onSearchInputChange: (value: string) => void;
  searchValue: string;
  consortium: Consortium | undefined;
  centreSelectVal: CentreBase | null;
  setCentreSelectVal: (val: CentreBase | null) => void;
  setSearchValue: (val: string) => void;
  dataQaId: string;
}

export const ModalTopSection = (props: Props): JSX.Element => {
  const {
    headerStr,
    onSearchInputChange,
    searchValue,
    consortium,
    setCentreSelectVal,
    setSearchValue,
    centreSelectVal,
    dataQaId,
  } = props;
  const renderCentre = (item: CentreBase): string => item.id;

  const onCentreChange = (val: CentreBase) => {
    setCentreSelectVal(val);
    setSearchValue('');
  };

  return (
    <div>
      <ModalTitleStyled data-qa-id={`${dataQaId}-candidate-work-header`}>{headerStr}</ModalTitleStyled>
      <ModalSubtitleStyled data-qa-id={`${dataQaId}-candidate-work-subheader`}>
        Candidates listed below are not included in the sample request. Please select the candidates for whom you want
        to request work for.
      </ModalSubtitleStyled>
      <StyledInputContainer>
        <TextField
          dataQaId='search-candidate'
          onChange={onSearchInputChange}
          placeholder='Search for candidates by number, name, mark'
          value={searchValue}
        />
      </StyledInputContainer>
      {consortium && (
        <StyledInputContainer>
          <Dropdown<CentreBase>
            data={consortium.centres}
            renderOption={renderCentre}
            renderSelectedOption={renderCentre}
            dataQaId='consortia-centre-select'
            onChange={onCentreChange}
            value={centreSelectVal}
            placeholder='Please select'
            title='Select series'
          />
        </StyledInputContainer>
      )}
    </div>
  );
};
